<script lang="ts">
  import { Router } from "svelte-navigator";
  import Header from "./components/Header.svelte";
  import AppRouter from "./components/AppRouter.svelte";
</script>

<Router primary={false}>
  <main>
    <div class="site">
      <Header />
      <AppRouter />
    </div>
  </main>
</Router>

<style lang="scss">
  .site {
    margin: auto;
    padding-left: 10px;
    padding-right: 10px;
    max-width: 840px;
  }
</style>
